import {
  EventNoteOutlined,
  Task,
  Language,
  QrCodeScanner,
  PhoneAndroid,
  FilterList,
  Pending,
  Group,
  Person,
  AccountCircle,
  Tune
} from "@mui/icons-material";
import { filter, includes, omitBy, pickBy } from "lodash";
import { USER_PERMISSIONS } from "src/constants";


export const WAREHOUSE_ADMIN_TABS = [
  {
    href: "/guard",
    icon: Task,
    title: "Tasks",
  },
  {
    href: "/guard/users",
    icon: Group,
    title: "Users",
  },
  {
    href: "/guard/filter",
    icon: FilterList,
    title: "Orders filter",
  },
  {
    href: "/guard/profile",
    icon: AccountCircle,
    title: "Profile",
  },
  {
    href: "/guard/customizations",
    icon: Tune,
    title: "Customizations",
  },
  {
    title: "Language",
    icon: Language,
    href: "/guard/language"
  }
]

export const WAREHOUSE_SUPERVISOR_TABS = (permissions) => ([
  {
    href: "/guard",
    icon: Task,
    title: "Tasks",
  },
  {
    icon: PhoneAndroid,
    title: "Mobile camera",
    children: filter([
      {
        href: "/guard/scanner_mobile?alignmentStatus=PICK_UP",
        title: "Incoming orders",
        permission: USER_PERMISSIONS.PICK_UP
      },
      {
        href: "/guard/scanner_mobile?alignmentStatus=DROP_OFF",
        title: "Outgoing orders",
        permission: USER_PERMISSIONS.DROP_OFF
      },
    ], v => includes(permissions, v?.permission))
  },
  {
    icon: QrCodeScanner,
    title: "Barcode scanner",
    children: filter([
      {
        href: "/guard/scanner_device?alignmentStatus=PICK_UP",
        title: "Incoming orders",
        permission: USER_PERMISSIONS.PICK_UP
      },
      {
        href: "/guard/scanner_device?alignmentStatus=DROP_OFF",
        title: "Outgoing orders",
        permission: USER_PERMISSIONS.DROP_OFF
      },
    ], v => includes(permissions, v?.permission))
  },
  {
    href: "/guard/orders_list",
    icon: EventNoteOutlined,
    title: "Scanned orders",
  },
  {
    href: "/guard/profile",
    icon: AccountCircle,
    title: "Profile",
  },
  {
    title: "Language",
    icon: Language,
    href: "/guard/language"
  }
])

export const FIRST_MILE_TABS = [
  {
    href: "/guard/pending_orders",
    icon: Pending,
    title: "Pending orders",
  },
  {
    href: "/guard/orders/ORDER_IN_SHIPPING_COMPANY",
    icon: EventNoteOutlined,
    title: "In warehouse",
  },
  {
    href: "/guard/orders/ORDER_PICKED_UP_FOR_DROP_OFF",
    icon: EventNoteOutlined,
    title: "Left the warehouse",
  },
]

export const BASIC_TABS = [
  {
    href: "/guard",
    icon: Task,
    title: "Tasks",
  },
  {
    href: "/guard/scanner",
    icon: PhoneAndroid,
    title: "Mobile camera",
  },
  {
    href: "/guard/orders/ORDER_IN_SHIPPING_COMPANY",
    icon: EventNoteOutlined,
    title: "In warehouse",
  },
  {
    href: "/guard/users",
    icon: Group,
    title: "Users",
  },
  {
    title: "Language",
    icon: Language,
    href: "/guard/language"
  }
]